import React from 'react';
import styled from '@emotion/styled';
import TemplateConfigurationModel from '../../../models/templating/api/TemplateConfigurationModel';
import { color_colors_growth, color_shades_lighter, color_text_default, color_text_light } from '../../../constants/colors';
import { style_border_default } from '../../../constants/stylesValues';
import { Link } from 'react-router-dom';
import AppliedApplicationTemplateModel from '../../../models/templating/api/AppliedApplicationTemplateModel';
import { css } from '@emotion/css';

const defaultImage = require('../../../content/images/icon.svg');
const templateIcon = require('../../../content/images/templates-icons/template-icon-light.svg');
const integrationIcon = require('../../../content/images/templates-icons/integration-icon-light.svg');
const readyIcon = require('../../../content/images/templates-icons/generate-content.svg');
const notEnabledIcon = require('../../../content/images/templates-icons/not-enabled.svg');

interface ModuleListItemProps {
    templateConfiguration: TemplateConfigurationModel
    appliedTemplate?: AppliedApplicationTemplateModel // null if not in use
    applicationId: string
}

const ModuleListItem: React.FC<ModuleListItemProps> = ({
    templateConfiguration,
    appliedTemplate,
    applicationId
}) => {

    return (
        <Link className={`${moduleLink} ac-framework-list-item ac-module-list-item`} to={appliedTemplate?.id ? `/v/apps/${applicationId}/modules/applied/${appliedTemplate.id}` : `/v/apps/${applicationId}/modules/${templateConfiguration?.id}/details`}>
            <CardBody>
                <CardHeader />
                <CardImageWrapper>
                    <img src={templateConfiguration?.imageUrl ?? defaultImage} />
                </CardImageWrapper>
                <InnerCardBody>
                    <p className="template-title">{appliedTemplate?.name?.length > 0 ? appliedTemplate.name : templateConfiguration?.name}</p>
                    <p className="template-byline">
                        <img src={templateConfiguration?.templateType == "Integration" ? integrationIcon : templateIcon} />
                        <span>{`${templateConfiguration?.templateType == "Integration" ? "Integration" : "Template"} - by ${templateConfiguration?.ownerName}`}</span>
                        <span className="version-label">{templateConfiguration?.currentVersion?.versionName ? `version: ${templateConfiguration.currentVersion.versionName}` : null}</span>
                    </p>
                    <CardDescription>
                        <p className="template-description">{templateConfiguration.shortDescription}</p>
                    </CardDescription>
                </InnerCardBody>
                <CardEnd>
                    <p className="template-status">
                        <span>{appliedTemplate ? "Enabled" : "Not Enabled"}</span>
                        <img src={appliedTemplate ? readyIcon : notEnabledIcon} />
                    </p>
                </CardEnd>
            </CardBody>
        </Link>)
}

const moduleLink = css`
    display: block;
`
const CardBody = styled.div(`
    border: ${style_border_default};
    box-sizing: border-box;
    border-radius: 8px;
    background: white;
    width: calc(100% - 64px);
    height: 160px;
    position: relative;
    margin-left: 32px;
    margin-top: 32px;
    overflow: hidden;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${color_text_default};
`);

const CardHeader = styled.div(`
    background: ${color_shades_lighter};
    width: 72px;
    height: 100%;
    border-right: ${style_border_default};
`);

const CardDescription = styled.div(`
    height: 85px;
    overflow: hidden;
`);

const CardImageWrapper = styled.div(`
    position: absolute;
    width: 96px;
    height: 96px;
    margin-left: 24px;
    background: white;
    border: ${style_border_default};
    border-radius: 8px;
    overflow: hidden;
    img {
        max-height: 100%;
        max-width: 100%;
    }
`);

const InnerCardBody = styled.div(`
    display: flex;
    flex-direction: column;
    margin-left: 80px;
    color: ${color_text_default};
    flex: 1;
    .template-title {
        margin-top: 16px;
        margin-bottom: 5px;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 32px;
    }
    .template-byline {
        display: flex;
        align-items: center;
        color: ${color_text_light};
        font-size: 14px;
        line-height: 20px;
        img {
            margin-right: 8px;
        }
        .version-label {
            padding-left: 8px;
        }
    }
    .template-description {
        margin-top: 24px;
    }
`)

const CardEnd = styled.div(`
    height: calc(100% - 48px);
    width: 200px;
    border-left: ${style_border_default};
    margin: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .template-price {
        display: flex;
        align-items: center;
        margin-right: 0;
        margin-left: auto;
        margin-bottom: 0;
        margin-top: auto;
        .price-label {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: ${color_text_light};
            display: block;
            margin-right: 8px;
        }
        .price-value {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 24px;
            display: block;
        }
    }
    .template-status {
        margin-right: 0;
        margin-left: auto;
        font-size: 14px;
        line-height: 20px;
        font-style: italic;
        color: ${color_text_light};
        display: flex;
        align-items: center;
        &.enabled {
            color: ${color_colors_growth};
        }
        img {
            width: 24px;
            margin-left: 8px;
        }
    }
`)

export default ModuleListItem
